import { Store } from '../ct';
import { localiseProperty } from './index';
import { ALGOLIA_ATTRIBUTES } from './algoliaAttributes';
import type { AlgoliaAttributeValue } from './algoliaAttributes';

const searchQueryListNotLocalised: AlgoliaAttributeValue[] = [
  ALGOLIA_ATTRIBUTES.CATEGORIES_KEY,
  ALGOLIA_ATTRIBUTES.SIZE,
  ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT,
];

export const searchQueryListToLocalise: AlgoliaAttributeValue[] = [
  ALGOLIA_ATTRIBUTES.PRODUCT_TYPE,
  ALGOLIA_ATTRIBUTES.PRODUCT_SUB_TYPES,
  ALGOLIA_ATTRIBUTES.CATEGORIES_NAME,
  ALGOLIA_ATTRIBUTES.COLOR,
  ALGOLIA_ATTRIBUTES.BRAND,
  ALGOLIA_ATTRIBUTES.TECHNOLOGIES,
  ALGOLIA_ATTRIBUTES.SUB_TECHNOLOGIES,
  ALGOLIA_ATTRIBUTES.FASTENING,
  ALGOLIA_ATTRIBUTES.STYLE_NAME,
  ALGOLIA_ATTRIBUTES.UPPER_MATERIAL,
  ALGOLIA_ATTRIBUTES.GENDER,
  ALGOLIA_ATTRIBUTES.REVIEW_RATING,
  ALGOLIA_ATTRIBUTES.HEEL_HEIGHT_GROUPS,
  ALGOLIA_ATTRIBUTES.FIT,
];

export const productSearchQueryAllowedList = (stores: Store[]): string[] => {
  return [
    ...searchQueryListNotLocalised,
    ...searchQueryListToLocalise.flatMap((property) => [
      ...stores.flatMap((store) => [...localiseProperty(property, store)]),
    ]),
  ];
};

export const productFacetAllowedList = (stores: Store[]): string[] => {
  return [
    ALGOLIA_ATTRIBUTES.SIZE,
    ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT,
    ...searchQueryListToLocalise.flatMap((property) => [
      ...stores.flatMap((store) => [...localiseProperty(property, store)]),
    ]),
  ];
};
